















































import Analytics from '@/services/Analytics'
import Vue from 'vue'
interface TemplateCard {
    title: string
    subtitle: string
    text?: string
    media: boolean
    content: string
    icon: string
    color: string
    image: string
}
export default Vue.extend({
    data: () => ({}),
    computed: {
        cards(): TemplateCard[] {
            return [
                {
                    title: 'Broadcast',
                    subtitle: 'Sales & Marketing Promo',
                    text: 'Tip: Use Canva to make an image',
                    content:
                        'Get 40% Off with the code SHOP50 Today.\n\nCheckout at\nwww.mywebsite.com',
                    media: true,
                    icon: 'bi-megaphone-fill',
                    color: '#a08ed0',
                    image: this.$images.salesAndMarketing
                },
                {
                    title: 'Broadcast',
                    subtitle: 'Staff Alerts',
                    text: 'Tip: Schedule ahead of time',
                    content:
                        "Hi {{ FirstName }}, Friendly reminder about tomorrow's all-hands meeting at 11AM in conference room A",
                    media: false,
                    icon: 'bi-megaphone-fill',
                    color: '#FFC862',
                    image: this.$images.staffAlerts
                },
                {
                    title: 'Broadcast',
                    subtitle: 'SMS Poll or Survey',
                    text: 'Tip: Setup an Autoresponder to track responses',
                    content:
                        "Hi {{ FirstName }} it's time for our annual survey!\n\nReply A, B, or C",
                    media: false,
                    icon: 'bi-megaphone-fill',
                    color: '#a08ed0',
                    image: this.$images.smsPollSurvey
                },
                {
                    title: 'Broadcast',
                    subtitle: 'Product Announcement',
                    content:
                        "We're live! Check out our latest arrivals by visiting our website",
                    media: true,
                    icon: 'bi-megaphone-fill',
                    color: '#FFC862',
                    image: this.$images.productAnnouncement
                },
                {
                    title: 'Broadcast',
                    subtitle: 'SMS Newsletter',
                    content:
                        "Hi {{ FirstName }}, Here's our latest newsletter.\n\nA lot has changed! Be sure to read the full scope on our website here:\n\nwww.MyBlog.com",
                    media: false,
                    icon: 'bi-megaphone-fill',
                    color: '#F8F5F2',
                    image: this.$images.smsNewsletter
                }
            ]
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        }
    },
    methods: {
        onTemplateSelected(card: TemplateCard): void {
            //  Grab the content from our card
            const txt = card.content

            //  Create our object that we want to use to apply our template
            const template = {
                message: txt,
                media: card.media
            }

            //  Notify analytics
            Analytics.track('BroadcastTemplateCenterSelected', {
                template: card.subtitle
            })

            //  Tell our parent
            this.$emit('submit', template)
        }
    }
})
